export { SearchablePeopleAttributeSelect } from './SearchablePeopleAttributeSelect';
